// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

export const GET_INTEGRATION = "mondoo.captain.Captain.GetIntegration";
